<template>
    <div class="main-container">
        <div v-if="loading" class="loader-container" style="text-align: center; margin-top:80px;">
            <b-spinner
                variant="dark"
                label="Spinning"
                class="login-loader"
            ></b-spinner>
        </div>
        <div style="text-align:left;">
            <b-form-group label="Individual radios">
                <b-form-radio v-model="select_year" name="some-radios" :value="true">{{ $t('text.select_year') }}</b-form-radio>
                <b-form-radio v-model="select_year" name="some-radios" :alue="false">{{ $t('text.select_specific_dates') }}</b-form-radio>
            </b-form-group>
            <div v-if="select_year">
                <p>{{ $t('text.write_year') }}</p>
                <b-form-input v-model="year_text" :placeholder="$t('text.placeholder_year')"></b-form-input>
                <p v-if="invalid_year" class="error-label">{{ $t('text.invalid_year') }}</p>
            </div>
            <div v-if="!select_year">
                <p>{{ $t('text.select_income_dates') }}</p>
                <HotelDatePicker
                    :alwaysVisible="false"
                    showWeekNumbers
                    :firstDayOfWeek="1"
                    :showYear="true"
                    :i18n="localeStrings"
                    :startingDateValue="start_date"
                    :endingDateValue="end_date"
                    :hoveringTooltip="false"
                    :startDate="new Date('2018-01-01')"
                    @check-in-changed="setStartDate($event)"
                    @check-out-changed="setEndDate($event)"
                />
            </div>
        </div>
        
        <div v-if="showIncome" class="income-container" style="text-align:left;">
            <p><b>{{ $t('text.selected_dates') }}: {{ start_date.toLocaleDateString("sv-SE") }} - {{ end_date.toLocaleDateString("sv-SE") }}</b></p>
            <p>{{ $t('text.income_family') }}: {{ income_family }} {{ $t('text.sek') }}</p>
            <p>{{ $t('text.income_external') }}: {{ income_external }} {{ $t('text.sek') }}</p>
            <p>{{ $t('text.income_total') }}: {{ income_total }} {{ $t('text.sek') }}</p>

        </div>
    </div>
</template>

<script>
import BookingApiService from "../../services/booking_api_service";
import HotelDatePicker from "vue-hotel-datepicker2";

export default {
    name: "IncomeAdminComponent",
    components: {
        HotelDatePicker
    },
    data() {
        return {
            loading: false,
            income_family: null,
            income_external: null,
            income_total: null,

            select_year: true,
            year_text: '',
            start_date: new Date(),
            end_date: new Date(),
            payed: false,
            invalid_year: false,

            locale_se: {
                "night": "Natt",
                "nights": "Nätter",
                "week": "vecka",
                "weeks": "veckor",
                "day-names": ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"],
                "check-in": "Check-in",
                "check-out": "Check-out",
                "month-names": [
                    "Januari",
                    "Februari",
                    "Mars",
                    "April",
                    "Maj",
                    "Juni",
                    "Juli",
                    "Augusti",
                    "September",
                    "Oktober",
                    "November",
                    "December",
                ],
                "tooltip": {
                    "halfDayCheckIn": "Tillgänglig CheckIn",
                    "halfDayCheckOut": "Tillgänglig CheckOut",
                    "saturdayToSaturday": "Endast Lördag till Söndag",
                    "sundayToSunday": "Endast Söndag till Söndag",
                    "minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
                },
            },
            locale_en: {
                "night": "Night",
                "nights": "Nights",
                "week": "week",
                "weeks": "weeks",
                "day-names": ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"],
                "check-in": "Check-in",
                "check-out": "Check-out",
                "month-names": [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ],
                "tooltip": {
                    "halfDayCheckIn": "Available CheckIn",
                    "halfDayCheckOut": "Available CheckOut",
                    "saturdayToSaturday": "Only Saturday to Saturday",
                    "sundayToSunday": "Only Sunday to Sunday",
                    "minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
                },
            },
        };
    },
    watch: {
        payed: function() {
            this.fetchIncome();
        },
        year_text: function() {
            if (this.year_text.length == 4) {
                let date = new Date(this.year_text);
                if (isNaN(date)) {
                    this.invalid_year = true;
                } else {
                    this.invalid_year = false;
                    this.start_date = new Date(date.getFullYear(), 0, 1);
                    this.end_date = new Date(date.getFullYear(), 11, 31);
                    this.fetchIncome();
                }
            } else {
                this.invalid_year = false;
            }
        },
    },
    computed: {
        showIncome() {
            return (this.income_family != null || this.income_external != null || this.income_total != null);
        },
        localeStrings() {
            return (this.$root.$i18n.locale == "en" ? this.locale_en : this.locale_se);
        },
    },
    methods: {
        async fetchIncome() {
            if (this.start_date != null && this.end_date != null) {
                this.loading = true;
                try {
                    const data = await BookingApiService.get_income_for_dates(
                        this.payed, 
                        this.start_date.toISOString().split('T')[0], 
                        this.end_date.toISOString().split('T')[0],
                    );
                    this.income_family = data.data.income_family
                    this.income_external = data.data.income_external
                    this.income_total = data.data.income_total
                    this.loading = false;
                } catch (error) {
                    this.loading = false;
                }
            }
            
        },
        setStartDate(date) {
            if (date != null) {
                date.setHours(12,0,0,0);
            }
            this.start_date = date;
        },
        setEndDate(date) {
            if (date != null) {
                date.setHours(12,0,0,0);
            }
            this.end_date = date;
            if (this.start_date != null && this.end_date != null) {
                this.fetchIncome();
            }
        },
    },
};
</script>

<style scoped>
.main-container {
    overflow: visible;
    background-color: transparent;
    padding-bottom: 40px;
}
.income-container {
    margin-top: 30px;
}
.error-label {
    color: #dc3545;
    font-size:14px;
    text-align:center;
    margin-top: 10px;
}
</style>
